/**
 * Whether this browser has opened Research. The sidebar's New badge hides
 * after the first visit. Kept in localStorage: it is a hint, not a record.
 */
export const RESEARCH_SEEN_KEY = "caseblink.research.seen";

/** Same-tab listeners. `storage` only fires in other tabs. */
export const RESEARCH_SEEN_EVENT = "caseblink-research-seen";

const storage = (): Storage | null => {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
};

/** True once Research has been opened in this browser. */
export const readResearchSeen = (): boolean => {
  try {
    return storage()?.getItem(RESEARCH_SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

/** Records the first visit and tells same-tab listeners (the sidebar). */
export const markResearchSeen = (): void => {
  const store = storage();
  if (!store) return;
  try {
    if (store.getItem(RESEARCH_SEEN_KEY) === "1") return;
    store.setItem(RESEARCH_SEEN_KEY, "1");
  } catch {
    return;
  }
  window.dispatchEvent(new Event(RESEARCH_SEEN_EVENT));
};

/** Subscribe to the flag, including a write from another tab. */
export const subscribeResearchSeen = (
  onStoreChange: () => void
): (() => void) => {
  if (typeof window === "undefined") return () => undefined;
  const onStorage = (event: StorageEvent) => {
    if (event.key === RESEARCH_SEEN_KEY || event.key === null) onStoreChange();
  };
  window.addEventListener(RESEARCH_SEEN_EVENT, onStoreChange);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(RESEARCH_SEEN_EVENT, onStoreChange);
    window.removeEventListener("storage", onStorage);
  };
};
